import { fillTemplate } from "../Template/templateService";
import { getEmailSignature } from "../Template/emailSignatures";
import { FieldValues } from "react-hook-form";
import { BackofficeUser } from "../../types/BackofficeUser";
import { ProductUnion } from "../../types/ProductUnion";
import { lowerFirstHtmlText } from "../utils";

export const aiTextFormatter = (
  product: ProductUnion,
  formValues: FieldValues,
  currentUser: BackofficeUser,
  scopeType: string,
  text: string,
  recipientType?: string,
  disableSalutationAndGreeting?: boolean
): string => {
  if (disableSalutationAndGreeting) {
    return text;
  }

  if (scopeType === "customExtrajudicialLetter") {
    let consequences = "";

    if (product.caseCategory === "enforceClaim") {
      consequences =
        "Nach fruchtlosem Fristablauf werden wir unserer Mandantschaft anraten, weitere rechtliche Schritte einzuleiten. Die Geltendmachung der außergerichtlichen Kosten unserer Inanspruchnahme bleibt vorbehalten.";
    } else if (product.caseCategory === "defendClaim") {
      consequences =
        "Sollten Sie Ihre Forderungen gerichtlich durchsetzen wollen, können Sie uns als prozessbevollmächtigt betrachten.";
    }

    return fillTemplate(
      `<p><%= salutation(product, formValues) %></p><p><%= getWeRepresentAllClients(product) %></p>${text}<p>${consequences}</p><p><%= greeting(product, formValues) %></p>`,
      product,
      formValues
    );
  } else if (scopeType === "customMessage") {
    let result = fillTemplate(
      `<p><%= salutation(product, formValues) %></p>${lowerFirstHtmlText(text)}`,
      product,
      formValues
    );
    result += getEmailSignature(currentUser, product, recipientType === "customer");

    return result;
  } else {
    return fillTemplate(
      `<p><%= salutation(product, formValues) %></p>${lowerFirstHtmlText(
        text
      )}<p><%= greeting(product, formValues) %></p>`,
      product,
      formValues
    );
  }
};
